export const iconFontAwesomeFoodBeverageBlender = (
	<i className="fa-solid fa-blender"></i>
);
